import { render, staticRenderFns } from "./SolucionesPage.vue?vue&type=template&id=2d5e2d2d&scoped=true"
import script from "./SolucionesPage.vue?vue&type=script&lang=js"
export * from "./SolucionesPage.vue?vue&type=script&lang=js"
import style0 from "./SolucionesPage.vue?vue&type=style&index=0&id=2d5e2d2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5e2d2d",
  null
  
)

export default component.exports